// extracted by mini-css-extract-plugin
module.exports = {"section":"xZpb_","wrapper":"_3mCJT","content-wrapper":"_1MUd3","contentWrapper":"_1MUd3","widget-title":"kdu6J","widgetTitle":"kdu6J","categoriesCarouselWrapper":"_14OK4"};